import React, { createContext, useContext, useState, ReactNode } from "react"
import type { UniqueIdentifier } from "@dnd-kit/core"

export interface DragIndexState {
    active: UniqueIdentifier
    over: UniqueIdentifier | undefined
    direction?: "left" | "right"
}

interface DragContextType {
    dragIndex: DragIndexState
    setDragIndex: React.Dispatch<React.SetStateAction<DragIndexState>>
}

const DragContext = createContext<DragContextType | null>(null)

interface DragProviderProps {
    children: ReactNode
}

export const DragProvider: React.FC<DragProviderProps> = ({ children }) => {
    const [dragIndex, setDragIndex] = useState<DragIndexState>({ active: -1, over: -1 })

    return <DragContext.Provider value={{ dragIndex, setDragIndex }}>{children}</DragContext.Provider>
}

export const useDragIndex = () => {
    const context = useContext(DragContext)
    if (!context) {
        throw new Error("useDragIndex must be used within a DragProvider")
    }
    return context
}
